import { Link } from "react-router-dom";
import { formatDate, formatRead, temaLabel } from "../lib/api";

// riga di una guida; `post` dall'API oppure segnaposto dalla copy
export const QuadernoRow = ({ post, index, testId }) => {
    const to = post.slug ? `/quaderni/${post.slug}` : "/quaderni";
    const date = post.date && post.date.includes("-") ? formatDate(post.date) : post.date;
    const read = post.read_minutes ? formatRead(post.read_minutes) : post.read;
    return (
        <Link className="quaderno" to={to} data-testid={testId} data-cursor>
            <span className="caption quaderno-num">
                {String(index + 1).padStart(2, "0")}
            </span>
            <span className="quaderno-body">
                <span className="quaderno-title">{post.title}</span>
                {post.summary && (
                    <span className="quaderno-summary">{post.summary}</span>
                )}
            </span>
            <span className="caption quaderno-meta">
                {post.tema && <span className="quaderno-tema">{temaLabel(post.tema)}</span>}
                <span>{date}</span>
                <span>{read}</span>
            </span>
        </Link>
    );
};
